import {removeLoadingState} from "../helpers";
import {initDocumentDownloads} from "./common";
import {initBsnEditPartial} from "./bsnEditPartial";

export function initOvereenkomstPage() {

    initBsnEditPartial();
    initDocumentDownloads();
    
    const signingButton = document.getElementById('signing');
    const MAX_RETRIES = 30;
    let retryCount = 0;

    if (!signingButton) return;
    signingPoll();
    
    function signingPoll() {
        signingButton.classList.add('loading');
        fetch('/Hypotheekaanvraag/CheckSignRedirectUri', { method: 'POST' })
            .then(function(response) {
                if (response.ok) return response.json();
                throw response;
            })
            .then(function(data) {
                if (data.RedirectUri && data.RedirectUri.length > 12) {
                    signingButton.addEventListener('click', () => window.location.href = data.RedirectUri);
                    removeLoadingState(signingButton);
                } else if (++retryCount < MAX_RETRIES) {
                    setTimeout(signingPoll, 2000);
                } else {
                    showError(500);
                }
            })
            .catch(function(response) {
                showError(response.status || 500);
            });
    }

    function showError(status) {
        const errorNotification = document.getElementById('signingErrorNotification');
        if (errorNotification) {
            errorNotification.removeAttribute('hidden');
            const errorDiv = errorNotification.querySelector('.error' + status);
            if (errorDiv) errorDiv.removeAttribute('hidden');
        }
    }
    
}